export default __webpack_public_path__ + "static/media/BG-botton.a2f03b95.png";